/* eslint-disable menti-react/filename-convention--jsx */
import { TitleSectionWithImage } from '../../ui/Components/VotingTitle';
import type { ModuleComponentProps } from '../types';

export function Content({ question }: ModuleComponentProps) {
  const { question_description, title_meta, image, question: title } = question;

  return (
    <TitleSectionWithImage
      description={question_description}
      title={title}
      meta={title_meta}
      image={image}
    />
  );
}
